<template>
  <div>
    <div v-if="isLeft(side)" class="mb-5">
      <row-section-header>
        <span slot="title">
          Nice to meet you.
        </span>
      </row-section-header>
      <p>
        Hello! My name is Stephanie and I’m a designer based in Vancouver, British Columbia. With a passion for visual design and an aim for creating products that people love. I enjoy making designs centred around the human experience...  especially interested where motion meets user interaction.
      </p>
      <p>
        When I’m not busy at work or studying design and usability, you can find me practicing hobbies like photography, on the slopes finally learning to ski, or watching movies curled up with my dog Yuki.
      </p>
    </div>
    <div v-if="isRight(side)" class="section-height">
      <row-section-header>
        <span slot="title">
          Some of My Skill Set
        </span>
      </row-section-header>
      <div class="row mb-5">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-4 px-0" v-for="icon in iconsetAbout">
              <img class="img p-1 icon mx-auto d-block" :src="['@/../static/' + icon.path]" :alt="icon.name">
              <p class="pt-2 pb-3 mx-auto text-center">{{ icon.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AffixedSectionBase from '@/components/AffixedSectionBase.js'

export default {
  name: 'about',
  mixins: [AffixedSectionBase],
  data: function () {
    return {
      iconsetAbout: [
        {
          path: 'ICONMograph.svg',
          title: 'Mograph',
        },
        {
          path: 'ICONUX.svg',
          title: 'UX',
        },
        {
          path: 'ICONIdeation.svg',
          title: 'Ideation',
        },
        {
          path: 'ICONStoryboarding.svg',
          title: 'Storyboards',
        },
        {
          path: 'ICONCommunication.svg',
          title: 'Communication',
        },
        {
          path: 'ICONTypography.svg',
          title: 'Typography',
        },
        {
          path: 'ICONAdobeCS.svg',
          title: 'Creative Suite',
        },
        {
          path: 'ICONIllustration.svg',
          title: 'Illustration',
        },
        {
          path: 'ICONAgile.svg',
          title: 'Agile Workflow',
        },
        {
          path: 'ICONSketch.svg',
          title: 'Sketch',
        },
        {
          path: 'ICONHTMLCSS.svg',
          title: 'HTML + CSS',
        },
        {
          path: 'ICON3DGraphics.svg',
          title: '3D Graphics',
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
img.icon {
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/main/About.vue